import AnimatedLoader from '../../../components/AnimatedLoader';
import '../../../styles/containers/SavingsCalculator/savingsCalculator.scss';
// import '../../../styles/containers/Prayer/components/select-faith.scss';
// import Faiths from './Faiths';
// import faiths from '../../../constants/PrayerFaithsConstants';
import React from 'react'
import {useEffect, useState} from 'react'
import useMoengage from '../../../hooks/useMoengage';
import NextButton from './NextButton';
import {Routes} from '../../../constants/RouterConstants';
import { Navigation } from '../../../services/NavigationService';
import NavigationSection from './NavigationSection';
import SavingsCalculatorConstants from '../../../constants/SavingsCalculatorConstants'
import SavingsCard from './SavingsCard';
import RoutingService from '../../../services/RoutingService';
import ThankYouFlower from '../../../assets/ThankYouFlower.png';

function ThankYouPage() {


    return (<div className='__main-container-thank-you' style={{ minHeight: '100vh' }}>
        <div className="container-fluid" style={{
            marginTop:'40%',
            marginLeft:'30%',
        }}>
            <img
                src={ThankYouFlower}
                alt="companyName"
            />
            <p style={{

                position: 'absolute',
                width: '317px',
                height: '36px',
                left: '22px',
                top: '310px',

                fontFamily: 'Open Sans',
                fontStyle: 'normal',
                fontWeight: 'bold',
                fontSize: '24px',
                lineHeight: '150%',
                /* identical to box height, or 36px */

                textAlign: 'center',

                color: '#FFFFFF',
            }}>Thanks for your interest</p>

        </div>
    </div>
    )
}

export default ThankYouPage





//earning.value== selectedEarning ?'3px solid #C69A00'
//earning.value== selectedEarning ?'#C69A00'